import { Injectable } from '@angular/core';
import { HttpService } from '@app/core/http/http.service';
import { Logger } from 'projects/shared/src/lib/shared/core/logger.service';
import { BaseAddress } from 'projects/shared/src/lib/shared/models/classes/base/BaseAddress';
import { Channel } from 'projects/shared/src/lib/shared/models/classes/channels/Channel';
import { ChannelCreateOptions } from 'projects/shared/src/lib/shared/models/classes/channels/ChannelCreateOptions';
import {
    ChannelCreateSubscriptionResponse,
} from 'projects/shared/src/lib/shared/models/classes/channels/ChannelCreateSubscriptionResponse';
import { ChannelUpdateOptions } from 'projects/shared/src/lib/shared/models/classes/channels/ChannelUpdateOptions';
import { InvoicePreview } from 'projects/shared/src/lib/shared/models/classes/invoices/InvoicePreview';
import { Response } from 'projects/shared/src/lib/shared/models/local/Response';
import { InteractableEntityService } from 'projects/shared/src/lib/shared/services/interactable-entity.service';
import { I18nService } from 'projects/shared/src/lib/shared/services/local/i18n.service';
import { map, Observable } from 'rxjs';

const log = new Logger('Channels Service');

@Injectable()
export class ChannelsService extends InteractableEntityService<Channel, ChannelCreateOptions, ChannelUpdateOptions> {

    // -----------------------------------------------------------------------------------------------------
    // @ CONSTRUCTOR
    // -----------------------------------------------------------------------------------------------------

    constructor(
        protected httpService: HttpService,
        protected i18nService: I18nService
    ) {
        super('channels', 'channels', httpService, i18nService);
    }

    // -----------------------------------------------------------------------------------------------------
    // @ PUBLIC INSTANCE METHODS
    // -----------------------------------------------------------------------------------------------------

    createSubscription(channelId: string, priceId: string, billingAccountId: string): Observable<ChannelCreateSubscriptionResponse> {
        return this.httpService
            .post<Response<ChannelCreateSubscriptionResponse>>(
                `channels/${channelId}/subscriptions`, { priceId, billingAccountId }
            ).pipe(
                map((result: Response<ChannelCreateSubscriptionResponse>) => {
                    return result.data;
                })
            );
    }

    createSubscriptionInvoicePreview(channelId: string, subscriptionId: string, address: { address: BaseAddress }): Observable<InvoicePreview> {
        return this.httpService
            .post<Response<InvoicePreview>>(
                `channels/${channelId}/subscriptions/${subscriptionId}/invoices/preview`, address
            ).pipe(
                map((result: Response<InvoicePreview>) => {
                    return result.data;
                })
            );
    }

    createCustomerSession(channelId: string, billingAccountId: string): Observable<string> {
        return this.httpService
            .post<any>(
                `channels/${channelId}/customer-session`, { billingAccountId }
            ).pipe(
                map((result: Response<string>) => {
                    return result.data;
                })
            );
    }
}
